import script from "./Spv.vue?vue&type=script&setup=true&lang=js"
export * from "./Spv.vue?vue&type=script&setup=true&lang=js"

import "./Spv.vue?vue&type=style&index=0&id=252a65a9&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-252a65a9"]])

export default __exports__